<template>
  <div class="flex flex-col gap-y-3">
    <div class="w-full flex justify-between">
      <slot name="header">
        <div class="w-full flex justify-between">
          <h1 class="text-xl md:text-2xl text-primary font-medium">
            {{ $t('controlPanel') }}
          </h1>
          <div class="flex gap-x-5">
            <RouterLink
              :to="{ name: 'IndAnnouncements' }"
              v-tippy="{ content: $t('announcemntAndInstruction') }"
              class="flex justify-center items-center"
            >
              <faBullhorn class="w-4 fill-primary"></faBullhorn>
            </RouterLink>
            <button
              v-if="!controlPanelStore.inEditMode"
              class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
              @click="controlPanelStore.inEditMode = true"
            >
              <div class="p-2 bg-primary rounded-s-md">
                <faPenToSquare class="w-4 fill-white"></faPenToSquare>
              </div>
              <span class="w-full text-center">
                {{ $t('editControlPanel') }}
              </span>
              <div class="p-0.5"></div>
            </button>
            <template v-if="controlPanelStore.inEditMode">
              <div class="flex gap-x-0.5">
                <button
                  class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
                  @click="controlPanelStore.onSaveLayout"
                >
                  <div class="p-2 bg-primary rounded-s-md">
                    <faDiskette class="w-4 fill-white"></faDiskette>
                  </div>
                  <span class="w-full text-center">
                    {{ $t('Save') }}
                  </span>
                  <div class="p-0.5"></div>
                </button>
                <button
                  class="text-center rounded-md bg-brand-gray-600/80 hover:bg-brand-gray-600 flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
                  @click="controlPanelStore.onCancel"
                >
                  <div class="p-2 bg-brand-gray-600 rounded-s-md">
                    <faTimes class="w-3 fill-white" />
                  </div>
                  <span class="w-full text-center">
                    {{ $t('Cancel') }}
                  </span>
                  <div class="p-0.5"></div>
                </button>
              </div>
            </template>
          </div>
        </div>
      </slot>
    </div>
    <CollapsibleSection
      v-if="controlPanelStore.inEditMode && controlPanelStore.hiddenBoxes.length > 0"
      :header-label="$t('availableControlPanels')"
      class="w-full"
    >
      <div class="w-full flex gap-4 flex-wrap">
        <button
          :key="key"
          v-for="(box, key) in controlPanelStore.hiddenBoxes"
          class="flex gap-x-2 border border-primary px-3 py-1 rounded-md group hover:bg-primary hover:text-white"
          @click="controlPanelStore.restoreBox(box)"
        >
          <faBox class="w-4 fill-primary group-hover:fill-white" />
          {{ $t(box.dashboardType.text) }}
        </button>
      </div>
    </CollapsibleSection>

    <!-- <template v-if="isLoading">
        <div
          :key="i"
          :data-swapy-slot="i"
          v-for="i in [1, 2, 2, 2, 2, 2, 2, 2, 2]"
          class="w-full min-h-[12rem] bg-primary/10 border border-primary flex flex-col gap-y-2 p-4 animate-pulse shadow-md"
        >
          <div class="w-20 h-20 rounded-full bg-primary/40"></div>
          <div class="w-full rounded-md py-2 bg-primary/40"></div>
          <div class="w-[86%] rounded-md py-2 bg-primary/40"></div>
        </div>
      </template> -->
    <div
      v-if="!isLoading"
      ref="container"
      class="control-panel__box-container w-full grid md:grid-cols-3 lg:grid-cols-4 gap-4"
    >
      <div
        :key="key"
        :data-swapy-slot="key"
        v-for="(item, key) in controlPanelStore.itemsForDisplay"
        class="w-full min-h-[12rem]"
      >
        <component
          :is="!controlPanelStore.inEditMode && item.path ? 'router-link' : 'div'"
          :to="item.path"
          :data-swapy-item="item.lookupDashboardTypesId"
          class="w-full h-full border border-primary rounded-md flex flex-col gap-y-2 p-4 shadow-sm relative bg-white"
        >
          <div v-if="controlPanelStore.inEditMode" class="absolute -top-3 -end-3">
            <button
              class="size-6 rounded-full bg-brand-red flex justify-center items-center"
              @click="controlPanelStore.markForRemoval(item)"
            >
              <faTimes class="w-3 fill-white" />
            </button>
          </div>
          <div class="w-full flex justify-between">
            <div class="w-20 h-20 rounded-full bg-primary/40 flex justify-center items-center">
              <i
                v-if="item?.config?.eChannelsIcon"
                :class="item?.config?.eChannelsIcon"
                class="text-white text-4xl"
              />
              <i v-else class="ica-custom-fonts-draft text-white text-3xl" />
            </div>
            <h3 class="text-primary font-bold text-5xl">
              {{ item.value }}
            </h3>
          </div>
          <h4 class="text-primary font-medium text-xl">{{ item.dashboardType.text }}</h4>
          <template v-if="item.boxElement.length > 0">
            <div class="border-t border-brand-grayblue-300 pt-3 w-full flex justify-evenly">
              <div
                v-for="(boxItem, key) in item.boxElement"
                :key="key"
                class="w-1/3 flex flex-col items-center gap-y-[2px]"
              >
                <div
                  :class="[
                    {
                      'border border-green-500 bg-green-200':
                        boxItem.dashboardElementTypes.id === 1,
                      'border border-red-500 bg-red-200': boxItem.dashboardElementTypes.id === 2,
                      'border border-amber-500 bg-amber-200': [3, 5].includes(
                        boxItem.dashboardElementTypes.id
                      ),
                      'border border-green-800 bg-green-800 text-white':
                        boxItem.dashboardElementTypes.id === 4
                    }
                  ]"
                  class="h-8 aspect-video flex justify-center items-center rounded-lg font-semibold"
                >
                  {{ boxItem.value }}
                </div>
                <small class="text-center"> {{ boxItem.dashboardElementTypes.text }} </small>
              </div>
            </div>
          </template>
        </component>
      </div>
    </div>
  </div>
</template>

<script setup>
import faBox from '@/assets/icons/faBox.svg?component'
import faTimes from '@/assets/icons/faTimes.svg?component'
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import faPenToSquare from '@/assets/icons/faPenToSquare.svg?component'
import faBullhorn from '@/assets/icons/faBullhorn.svg?component'
import axios from '@/services'
import { onMounted, ref, nextTick } from 'vue'
import { useControlPanelStore } from '@/stores/control_panel'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { createSwapy } from 'swapy'

const isLoading = ref(true)
const container = ref(null)

const controlPanelStore = useControlPanelStore()

onMounted(async () => {
  const dashboardItems = await axios.get('/api/dashboard/getUserDashboardSetup')

  controlPanelStore.items = dashboardItems.map((item) => {
    const config = JSON.parse(item.config)
    const path = config && extractPath(config.eChannelsRedirectUrl)
    return {
      ...item,
      id: item.dashboardType.id,
      path,
      config
    }
  })

  isLoading.value = false
  await nextTick()

  const swapy = createSwapy(container.value)
  swapy.onSwap(({ data }) => {
    localStorage.setItem('slotItem', JSON.stringify(data.object))
  })
})

function extractPath(path) {
  const regex = /^#\/(.+?)(?:\?.*)?$/
  const match = regex.exec(path)
  return match ? match[1] : path.slice(1) // Remove # if no match
}
</script>

<style lang="scss" scoped></style>
